import { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router';
import ErrorRoute from './features/error/routes/ErrorRoute';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { LoadingSpinner } from '@uhg-abyss/web/ui/LoadingSpinner';
import { ChatScreen } from './optumus/optumus-chat/src/screens/ChatScreen';
import { RedirectProvider } from './optumus/optumus-chat/src/context/RedirectContext.tsx';

function LoadingFallback() {
  return (
    <Flex justify="center" alignItems="center" css={{ minHeight: '100vh' }}>
      <LoadingSpinner size="lg" ariaLoadingLabel="Loading…" />
    </Flex>
  );
}

export default function App() {
  return (
    <RedirectProvider>
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          <Route path="/optumus" element={<ChatScreen />} />
          <Route path="/error" element={<ErrorRoute />} />
          <Route path="*" element={<Navigate to="/error?code=NOT_FOUND" replace />} />
        </Routes>
      </Suspense>
    </RedirectProvider>
  );
}
